module.exports = __webpack_public_path__ + "img/Group 27905@2x.3173f2f5.png";